import { Box, styled } from '@mui/material';

const SliderWrapper = styled(Box)({
  flex: 1,
  position: 'relative',
  padding: '0 0 4px',
});

export default SliderWrapper;